export const loans = {
  en: {
    newAdvance: "New salary advance",
    importExisting: "Record an existing advance",
    activeAdvances: "Active salary advances",
    nobodyOwes: "Nobody has an outstanding salary advance.",
    totalOutstanding: "Total outstanding",
    monthlyRecovery: "Recovered monthly",
    acrossNPeople: "across {n} people",
    perMonth: "from next payroll",
    advances: "Advances",
    advancesTitle: "Advances / Loans",
    noAdvances: "No advances yet.",
    deductionHistory: "Deduction History",
    addDeduction: "Record a deduction",
    fromPayrollRun: "From a payroll run",
    expectedCompletion: "Expected completion",
    projected: "(projected)",
    neverAtThisRate: "No deduction set",
    noDeductionSet: "None set",
    open: "Open",
    searchByName: "Search by name",
    forThisPerson: "Selected employee",
    importWhatThisDoes: "For advances that started before Alba",
    importPoint1: "Enter the original amount and what is still owed. The difference is recorded as one opening repayment — the history is not reconstructed month by month.",
    importPoint2: "After that it behaves exactly like an advance created here: payroll deducts from it and the balance falls.",
    importPoint3: "Deductions resume next month unless you set a different first deduction below.",
    description: "Description",
    importTitle: "Record advances carried over",
    importIntro: "For advances granted before Alba. Add the advances, add the deductions that were taken against them, and stop there. Every other figure — what each advance has repaid, what it still owes — is worked out by replaying those deductions oldest advance first, exactly as payroll does it.",
    importStepAdvances: "1 · The advances",
    importStepDeductions: "2 · The deductions taken",
    importDeductionsIntro: "What actually came off, month by month. Amounts that differ are just rows with different figures — nothing needs adding up, and no per-advance balance is needed. The split across advances is worked out below.",
    importAddDeduction: "Add a deduction",
    importRunFrom: "Starting",
    importDeductionUndated: "{count} deductions have no date. Each one needs the month it was taken, or remove it.",
    importAddRow: "Add another advance",
    importTotalRepaid: "Total repaid so far",
    importTotalOutstanding: "Total outstanding today",
    importRunMonths: "Months",
    importRunAmountEach: "Amount each month",
    importRunSubtotal: "Comes to",
    importAddRun: "Add a different amount",
    importDeductionHeading: "Monthly deduction",
    importDeductionMode: "This deduction",
    importDeductionReplace: "replaces what is set now",
    importDeductionKeep: "is left exactly as it is",
    importDeductionAdd: "is added to what is set now",
    importDeductionCurrent: "This person currently has {amount} deducted each month.",
    importPreviewHeading: "Check this against your sheet",
    importPreviewNote: "Money comes off the oldest advance first, so the earliest is settled before the next is touched. These are the figures that will be saved.",
    importDuplicateWarning: "More than one advance is called {names}. That is fine if they really are separate advances — worth a look if it was a mis-paste.",
    importRepaidTooHigh: "The repaid figure is more than the total advanced. Check it against your sheet.",
    importIncomplete: "Every advance needs a description, an amount above zero and a date.",
    importSubmit: "Record all of them",
    originalAmount: "Original advance amount",
    currentOutstanding: "Current outstanding balance",
    currentMonthlyDeduction: "Current monthly deduction",
    originalIssueDate: "Original issue date",
    firstDeductionHere: "First deduction in Alba (optional)",
    agreedCompletion: "Agreed completion date (optional)",
    willRecordRepaid: "{amount} will be recorded as already repaid.",
    deductionAddsUp: "This is added to any deduction the employee already has. One deduction per person covers all their advances.",
    recordAdvance: "Record advance",
    carriedOver: "Advance carried over from the previous system",
    deductionIsPerPerson: "The monthly deduction is set once for this employee and covers all their advances together.",
    editDeduction: "Set monthly deduction",
    deductionTitle: "Monthly deduction",
    deductionNote: "One amount for this employee, taken with each payroll run and applied to their oldest advance first. Set it to zero to stop deductions entirely.",
    deductionAmount: "Amount per month",
    deductionCapped: "Only {amount} SAR will be taken this month, because that is all that is still owed.",
    choosePerson: "Choose an employee…",
    chooseFirst: "Choose an employee to see their advances.",
    listTitle: "Advances",
    historyTitle: "Repayment history",
    noneForPerson: "No advances for this employee.",
    reason: "Reason",
    reasonPlaceholder: "What the advance is for",
    totalAdvanced: "Total advanced",
    combinedPosition: "What this person owes",
    combinedPositionNote: "Across all {count} advances. Alba deducts one amount per person per month; which advance a payment clears is bookkeeping, not a separate balance.",
    stillOwed: "Still owed",
    totalRepaid: "Total repaid",
    remaining: "Remaining balance",
    monthlyDeduction: "Monthly deduction",
    nextDeduction: "Next deduction",
    estimatedCompletion: "Estimated completion",
    balanceAfter: "Balance after",
    nothingBeingDeducted: "There is a balance outstanding but nothing is being deducted. Every advance is paused, settled or written off.",
    firstDeductionYear: "First deduction year",
    firstDeductionMonth: "First deduction month",
    firstDeductionNote: "Deductions begin with the payroll run for this month.",
    newLoan: "New salary advance",
    detailTitle: "Salary advance",
    principal: "Amount advanced",
    repaid: "Repaid so far",
    outstanding: "Outstanding",
    firstDeduction: "First deduction",
    schedule: "Repayments",
    noRepayments: "Nothing has been repaid yet.",
    source: "Source",
    sourcePayroll: "Payroll",
    sourceManual: "Recorded by hand",
    recordRepayment: "Record a repayment",
    repaymentIntro: "Enter what was paid. It comes off the oldest advance first, exactly as a payroll deduction does — {amount} is owed in total.",
    repaymentSplitHeading: "Where it goes",
    repaymentExceeds: "This is {extra} more than the {owed} still owed. Saving it needs authority.",
    outstandingAfter: "Left after",
    advance: "Advance",
    settledLabel: "settled",

    // ── Papers attached to one advance ───────────────────────────────────────
    // The invoice it paid, the signed acknowledgement, the transfer receipt.
    // "Papers" rather than "attachments": it is what they are, and it does not
    // ask anybody to think about the software.
    filesButton: "Papers",
    /** The count is on the button, so nought is worth distinguishing. */
    filesButtonCount: "Papers ({count})",
    filesTitle: "Papers",
    filesEmpty: "Nothing attached to this advance.",
    fileAdd: "Attach a paper",
    fileName: "What is it?",
    fileChoose: "File (PDF, PNG or JPEG, up to 10 MB)",
    filePickOne: "Choose a file first.",
    fileNameRequired: "Give it a name, so it can be recognised later.",
    fileTooLarge: "That file is larger than 10 MB.",
    fileUnsupportedType: "Only PDF, PNG and JPEG files can be attached.",
    fileUnreadable: "That file could not be read. Please choose it again.",
    repaymentPerAdvance: "Pay off one specific advance instead",
    recordRepaymentFor: "Record a repayment — {name}",
    outstandingIs: "Outstanding balance: {amount} SAR",
    pause: "Pause deductions",
    resume: "Resume deductions",
    markSettled: "Mark as settled",
    cancel: "Write off",
    statusChangeTitle: "Change the status of this advance?",
    explain_active: "Deductions resume from the next payroll run.",
    explain_paused: "Deductions stop. The balance is unchanged and nothing is forgiven.",
    explain_settled: "The advance is closed and no further deductions are taken, even if a balance remains.",
    explain_cancelled: "The remaining balance is written off and will never be deducted.",

    viewDetails: "View details",
    hideDetails: "Hide details",
    activeLoanBadge: "Active advance",
    oneAdvance: "1 advance",
    numberOfAdvances: "{n} advances",
    financialSummary: "Financial Summary",
    salaryAdvances: "Salary Advances",
    historicalAdvances: "Historical Imported Advances",
    imported: "imported",
    totalAdvancedTile: "TOTAL ADVANCED",
    addAdvance: "+ Add Advance",
    editAdvance: "Edit advance",
    saveAdvance: "Save",
    deleteAdvance: "Delete",
    deleteAdvanceTitle: "Delete this advance?",
    deleteAdvanceBody: "This removes the advance permanently. It has no repayments recorded against it, so nothing else is affected.",
    cannotDeleteHasRepayments: "Cannot be deleted — repayments are recorded against it. Use Write off instead.",
    issuedOn: "Date issued",
    repayments: "Repayments",
    addRepayment: "+ Add Repayment",
    editRepayment: "Edit repayment",
    deleteRepaymentTitle: "Delete this repayment?",
    deleteRepaymentBody: "This removes the repayment permanently and the advance's balance is recalculated without it.",
    viaPayroll: "via payroll",
    manualEntry: "manual entry",
    protectedTooltip: "Generated by payroll — cannot be edited or deleted here.",
    basedOnPerMonth: "based on {amount} SAR/month",

    overrideTitle: "Override this rule?",
    overrideExplain: "This rule normally protects the accuracy of this record. As Super Admin you may proceed anyway — give a reason, and it is recorded in the audit trail together with the values this changes.",
    overrideProceed: "Proceed anyway",

    loanStatusLabel: "Loan status",
  },
  ar: {
    newAdvance: "سلفة جديدة",
    importExisting: "تسجيل سلفة قائمة",
    activeAdvances: "السلف القائمة",
    nobodyOwes: "لا يوجد موظف عليه سلفة قائمة.",
    totalOutstanding: "إجمالي المتبقي",
    monthlyRecovery: "التحصيل الشهري",
    acrossNPeople: "على {n} موظفين",
    perMonth: "من المسيّر القادم",
    advances: "عدد السلف",
    advancesTitle: "السلف",
    noAdvances: "لا توجد سلف بعد.",
    deductionHistory: "سجل الخصومات",
    addDeduction: "تسجيل خصم",
    fromPayrollRun: "من مسير الرواتب",
    expectedCompletion: "تاريخ السداد المتوقع",
    projected: "(تقديري)",
    neverAtThisRate: "لا يوجد خصم محدد",
    noDeductionSet: "غير محدد",
    open: "فتح",
    searchByName: "البحث بالاسم",
    forThisPerson: "الموظف المحدد",
    importWhatThisDoes: "للسلف التي بدأت قبل استخدام ألبا",
    importPoint1: "أدخل المبلغ الأصلي والمتبقي. يُسجَّل الفرق كدفعة سداد افتتاحية واحدة، دون إعادة بناء السجل شهراً بشهر.",
    importPoint2: "بعد ذلك تعمل تماماً كأي سلفة تُنشأ هنا: يخصم منها المسيّر وينخفض الرصيد.",
    importPoint3: "تستأنف الخصومات الشهر القادم ما لم تحدد تاريخاً آخر أدناه.",
    description: "الوصف",
    importTitle: "تسجيل سلف سابقة",
    importIntro: "للسلف الممنوحة قبل ألبا. أضف السلف، ثم أضف الخصومات التي استُقطعت منها، وتوقف عند ذلك. كل رقم آخر — ما سُدد من كل سلفة وما تبقى عليها — يُحسب بإعادة تطبيق تلك الخصومات على أقدم سلفة أولاً، تماماً كما يفعل مسير الرواتب.",
    importStepAdvances: "1 · السلف",
    importStepDeductions: "2 · الخصومات المستقطعة",
    importDeductionsIntro: "ما تم خصمه فعلاً، شهراً بشهر. المبالغ المختلفة هي مجرد صفوف بأرقام مختلفة — لا حاجة لجمع أي شيء، ولا لرصيد لكل سلفة. يُحسب التوزيع على السلف بالأسفل.",
    importAddDeduction: "إضافة خصم",
    importRunFrom: "ابتداءً من",
    importDeductionUndated: "{count} من الخصومات بلا تاريخ. كل خصم يحتاج شهر استقطاعه، أو احذفه.",
    importAddRow: "إضافة سلفة أخرى",
    importTotalRepaid: "إجمالي المسدد حتى الآن",
    importTotalOutstanding: "إجمالي المتبقي اليوم",
    importRunMonths: "عدد الأشهر",
    importRunAmountEach: "المبلغ الشهري",
    importRunSubtotal: "المجموع",
    importAddRun: "إضافة مبلغ مختلف",
    importDeductionHeading: "الخصم الشهري",
    importDeductionMode: "هذا الخصم",
    importDeductionReplace: "يحل محل الخصم الحالي",
    importDeductionKeep: "يُترك كما هو تماماً",
    importDeductionAdd: "يُضاف إلى الخصم الحالي",
    importDeductionCurrent: "لدى هذا الموظف حالياً خصم شهري بمبلغ {amount}.",
    importPreviewHeading: "قارن هذا بكشفك",
    importPreviewNote: "يُخصم المبلغ من أقدم سلفة أولاً، فتُسدَّد الأقدم بالكامل قبل أن تُمس التالية. هذه هي الأرقام التي ستُحفظ.",
    importDuplicateWarning: "أكثر من سلفة تحمل الاسم {names}. لا بأس إن كانت سلفاً منفصلة فعلاً — راجعها إن كان اللصق خاطئاً.",
    importRepaidTooHigh: "المبلغ المسدد أكبر من إجمالي السلف. راجعه مع كشفك.",
    importIncomplete: "كل سلفة تحتاج إلى وصف ومبلغ أكبر من صفر وتاريخ.",
    importSubmit: "تسجيلها جميعاً",
    originalAmount: "مبلغ السلفة الأصلي",
    currentOutstanding: "الرصيد المتبقي حالياً",
    currentMonthlyDeduction: "الخصم الشهري الحالي",
    originalIssueDate: "تاريخ صرف السلفة",
    firstDeductionHere: "أول خصم في ألبا (اختياري)",
    agreedCompletion: "تاريخ السداد المتفق عليه (اختياري)",
    willRecordRepaid: "سيُسجَّل مبلغ {amount} كمسدَّد مسبقاً.",
    deductionAddsUp: "يُضاف هذا إلى أي خصم قائم للموظف. خصم واحد لكل موظف يغطي جميع سلفه.",
    recordAdvance: "تسجيل السلفة",
    carriedOver: "سلفة منقولة من النظام السابق",
    deductionIsPerPerson: "يُحدد الخصم الشهري مرة واحدة لهذا الموظف ويغطي جميع سلفه معاً.",
    editDeduction: "تحديد الخصم الشهري",
    deductionTitle: "الخصم الشهري",
    deductionNote: "مبلغ واحد لهذا الموظف يُخصم مع كل مسير رواتب ويُطبّق على أقدم سلفة أولاً. اجعله صفراً لإيقاف الخصم تماماً.",
    deductionAmount: "المبلغ شهرياً",
    deductionCapped: "سيتم خصم {amount} ريال فقط هذا الشهر لأنه المتبقي.",
    choosePerson: "اختر موظفاً…",
    chooseFirst: "اختر موظفاً لعرض سلفه.",
    listTitle: "السلف",
    historyTitle: "سجل السداد",
    noneForPerson: "لا توجد سلف لهذا الموظف.",
    reason: "السبب",
    reasonPlaceholder: "الغرض من السلفة",
    totalAdvanced: "إجمالي المصروف",
    combinedPosition: "إجمالي ما على الموظف",
    combinedPositionNote: "لجميع السلف البالغ عددها {count}. يُخصم مبلغ واحد شهرياً لكل موظف، وتوزيعه على السلف قيد محاسبي وليس رصيداً منفصلاً.",
    stillOwed: "المتبقي في الذمة",
    totalRepaid: "إجمالي المسدد",
    remaining: "الرصيد المتبقي",
    monthlyDeduction: "الخصم الشهري",
    nextDeduction: "الخصم القادم",
    estimatedCompletion: "الاكتمال المتوقع",
    balanceAfter: "الرصيد بعد",
    nothingBeingDeducted: "يوجد رصيد متبقٍ ولكن لا يتم خصم أي مبلغ. جميع السلف موقوفة أو مغلقة أو معفاة.",
    firstDeductionYear: "سنة أول خصم",
    firstDeductionMonth: "شهر أول خصم",
    firstDeductionNote: "يبدأ الخصم مع مسير رواتب هذا الشهر.",
    newLoan: "سلفة جديدة",
    detailTitle: "سلفة على الراتب",
    principal: "المبلغ المصروف",
    repaid: "المسدد حتى الآن",
    outstanding: "المتبقي",
    firstDeduction: "أول خصم",
    schedule: "السداد",
    noRepayments: "لم يتم سداد أي مبلغ بعد.",
    source: "المصدر",
    sourcePayroll: "مسير الرواتب",
    sourceManual: "مسجل يدوياً",
    recordRepayment: "تسجيل سداد",
    repaymentIntro: "أدخل المبلغ المدفوع. يُخصم من أقدم سلفة أولاً، تماماً كخصم المسير — إجمالي المديونية {amount}.",
    repaymentSplitHeading: "أين يذهب المبلغ",
    repaymentExceeds: "هذا المبلغ يزيد {extra} عن المديونية البالغة {owed}. حفظه يتطلب صلاحية استثنائية.",
    outstandingAfter: "المتبقي بعده",
    advance: "السلفة",
    settledLabel: "مسددة",

    filesButton: "المرفقات",
    filesButtonCount: "المرفقات ({count})",
    filesTitle: "المرفقات",
    filesEmpty: "لا يوجد مرفق لهذه السلفة.",
    fileAdd: "إرفاق ملف",
    fileName: "ما هو الملف؟",
    fileChoose: "الملف (PDF أو PNG أو JPEG، حتى 10 ميجابايت)",
    filePickOne: "اختر ملفاً أولاً.",
    fileNameRequired: "اكتب اسماً للملف حتى يمكن التعرف عليه لاحقاً.",
    fileTooLarge: "حجم الملف أكبر من 10 ميجابايت.",
    fileUnsupportedType: "يمكن إرفاق ملفات PDF و PNG و JPEG فقط.",
    fileUnreadable: "تعذر قراءة هذا الملف. يرجى اختياره مرة أخرى.",
    repaymentPerAdvance: "سداد سلفة محددة بدلاً من ذلك",
    recordRepaymentFor: "تسجيل سداد — {name}",
    outstandingIs: "الرصيد المتبقي: {amount} ريال",
    pause: "إيقاف الخصم مؤقتاً",
    resume: "استئناف الخصم",
    markSettled: "إغلاق السلفة",
    cancel: "إعفاء من المتبقي",
    statusChangeTitle: "تغيير حالة هذه السلفة؟",
    explain_active: "يستأنف الخصم من مسير الرواتب القادم.",
    explain_paused: "يتوقف الخصم. يبقى الرصيد كما هو ولا يتم الإعفاء من أي مبلغ.",
    explain_settled: "تُغلق السلفة ولا تُخصم أي أقساط أخرى حتى لو بقي رصيد.",
    explain_cancelled: "يتم الإعفاء من الرصيد المتبقي ولن يُخصم مطلقاً.",

    viewDetails: "عرض التفاصيل",
    hideDetails: "إخفاء التفاصيل",
    activeLoanBadge: "سلفة قائمة",
    oneAdvance: "سلفة واحدة",
    numberOfAdvances: "{n} سلف",
    financialSummary: "الملخص المالي",
    salaryAdvances: "السلف على الراتب",
    historicalAdvances: "السلف المستوردة من النظام السابق",
    imported: "مستوردة",
    totalAdvancedTile: "إجمالي المصروف",
    addAdvance: "+ إضافة سلفة",
    editAdvance: "تعديل السلفة",
    saveAdvance: "حفظ",
    deleteAdvance: "حذف",
    deleteAdvanceTitle: "حذف هذه السلفة؟",
    deleteAdvanceBody: "سيتم حذف السلفة نهائياً. لا يوجد سداد مسجل عليها، لذا لن يتأثر شيء آخر.",
    cannotDeleteHasRepayments: "لا يمكن الحذف — يوجد سداد مسجل عليها. استخدم الإعفاء بدلاً من ذلك.",
    issuedOn: "تاريخ الصرف",
    repayments: "السداد",
    addRepayment: "+ إضافة سداد",
    editRepayment: "تعديل السداد",
    deleteRepaymentTitle: "حذف هذا السداد؟",
    deleteRepaymentBody: "سيتم حذف هذا السداد نهائياً وسيُعاد احتساب رصيد السلفة بدونه.",
    viaPayroll: "عبر مسير الرواتب",
    manualEntry: "إدخال يدوي",
    protectedTooltip: "ناتج عن مسير الرواتب — لا يمكن تعديله أو حذفه من هنا.",
    basedOnPerMonth: "بناءً على {amount} ريال شهرياً",

    overrideTitle: "تجاوز هذه القاعدة؟",
    overrideExplain: "تحمي هذه القاعدة عادةً دقة هذا السجل. بصفتك مدير النظام يمكنك المتابعة رغم ذلك — أدخل سبباً، وسيُسجَّل في سجل التدقيق مع القيم التي يغيرها هذا الإجراء.",
    overrideProceed: "المتابعة رغم ذلك",

    loanStatusLabel: "حالة السلفة",
  },
} as const;
